import useStore from '../../store/store'
import { handleStepFour, handleStepTwo } from '../../utils/_handleSteps';

const NavigationMobile = ({ isBtnDisabled = false, setIsBtnDisabled = () => {}, action = () => {} }) => { 
  const { 
    step, 
    increaseStep, 
    decreaseStep, 
    rooms, 
    setActiveRoom, 
    setArrivalDate, 
    activeRoom, 
    setActiveGuest, 
    arrivalDate, 
    updatePrice,
    setExpress,
    setExpressCount,
  } = useStore((state) => state);

  const btnNextText = step < 5 ? 'Далее' : 'Отправить заявку';

  const currentRoom = rooms.find(item => item.id === activeRoom) || rooms[0];

  const scrollToTop = () => {
    setTimeout(() => {
      window.scrollTo({top: document.querySelector('.bron-header')?.getBoundingClientRect()?.bottom || 0, behavior: 'smooth'})
    },0)
  }

  const handleNextStep = () => {
    scrollToTop();
    switch (step) {
      case 1:
        increaseStep();
        setActiveRoom(rooms[0].id);
        break;

      case 2:
        handleStepTwo(rooms, setActiveRoom, setActiveGuest, currentRoom, increaseStep, decreaseStep, setIsBtnDisabled, false);
        break;

      case 3:
        handleStepTwo(rooms, setActiveRoom, setActiveGuest, currentRoom, increaseStep, decreaseStep, setIsBtnDisabled, false);
        break;

      case 4:
        handleStepFour(rooms, arrivalDate, setArrivalDate, updatePrice, setExpress, increaseStep, decreaseStep, false, setExpressCount);
        break;
      case 5:
        action();
        break;

      default:
        break;
    }
  }

  const handlePrevStep = () => {
    scrollToTop();
    switch (step) {
      case 1:
        break;

      case 2:
        handleStepTwo(rooms, setActiveRoom, setActiveGuest, currentRoom, increaseStep, decreaseStep, setIsBtnDisabled, true);
        break;

      case 3:
        handleStepTwo(rooms, setActiveRoom, setActiveGuest, currentRoom, increaseStep, decreaseStep, setIsBtnDisabled, true);
        break;

      case 4:
        handleStepFour(rooms, arrivalDate, setArrivalDate, updatePrice, setExpress, increaseStep, decreaseStep, true);
        break;

        case 5:
          decreaseStep();
          break;

      default:
        break;
    }
  }
  return (
    <div className='NavigationMobile__wrapper'>
        <button type='button' onClick={() => handlePrevStep()} disabled={step === 1} className='NavigationMobile__button back'>Назад</button>
        <button type='button' onClick={() => handleNextStep()} disabled={isBtnDisabled} className='NavigationMobile__button next'>{btnNextText}</button>
    </div>
  )
}

export default NavigationMobile